import { api } from '@/api'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import Title from '@/components/Title'
import WantToHoldChamp from '@/components/WantToHoldChamp'
import { usePage } from '@/hooks'
import useGame from '@/hooks/useGame'
import { IChampionship } from '@/interfaces/Championship'
import React, { useEffect, useState } from 'react'
import ChampionshipInfo from './components/ChampionshipInfo'
import ChampionshipMembers from './components/ChampionshipMembers'
import style from './styles/champ_detail.module.scss'

const ChampionshipDetail = (): React.ReactElement => {
  const [championship, setChampionship] = useState<IChampionship>()

  const page = usePage()
  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  const gameInfo =
    championship !== undefined
      ? useGame(championship.property_jeka_version_value)
      : undefined

  const ageValue =
    championship?.property_age_group_value !== '' &&
    championship?.property_age_group_value !== null
      ? championship?.property_age_group_value
      : undefined

  const gameDetailUrl =
    championship?.game_id !== undefined
      ? `${config.detail_game}?element_id=${String(championship?.game_id)}`
      : undefined

  useEffect(() => {
    api
      .getChampionship({ id: object.id })
      .then((data) => {
        setChampionship(data)
      })
      .catch((error) => {
        console.log(error, 'error')
      })
  }, [])

  return (
    <>
      <Container>
        <BackLink href={config.championships} title='Все чемпионаты' />
        <Title type='h1' hidden className={style.detail__title}>
          {object.title}
        </Title>

        <ChampionshipInfo
          gameInfo={gameInfo}
          ageValue={ageValue}
          championship={championship}
          title={object.title}
          gameDetailUrl={gameDetailUrl}
          gameDescription={object.detail}
        />

        <ChampionshipMembers championshipId={object.id} />
      </Container>

      <WantToHoldChamp
        title='Хотите провести Чемпионат по обучающей игре «ЖЭКА» в Вашем регионе?'
        blueButtonText='Скачать инструкцию'
      />
    </>
  )
}

export default ChampionshipDetail
